// HomeWeb.jsx
import React, { useState, useRef } from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, TouchableWithoutFeedback, TextInput, KeyboardAvoidingView, Alert } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from '../components/baseWeb';
import styles from '../styles/formularios';
import axios from 'axios';
import Checkbox from 'expo-checkbox';
import DescricaoModal from '../../screens/modal/DescricaoModalWeb';

import MaskInput, { Masks } from 'react-native-mask-input'; // Para aplicar máscara no CPF
export default function AutorizacaoDeVendaWeb() {
    const navigation = useNavigation();
    // envio unico 

    const icons = {

        Imobiliária: {
            default: require('../../assets/icons/cnpj.png'),
            selected: require('../../assets/icons/cnpj_white.png'),
        },
        Corretor: {
            default: require('../../assets/icons/2perfil.png'),
            selected: require('../../assets/icons/perfil.png'),
        }
    };

    const [usuario_id, setUsuario_id] = useState(null);
    const [emailUser, setEmailUser] = useState(null);

    console.log(usuario_id)


    const [loading, setLoading] = useState(false); // Estado para controlar o carregamento

    const [isSubmitting, setIsSubmitting] = useState(false);

    const [valorVendaImovel, setValorVendaImovel] = useState(''); // OK    
    const [cpf, setCpf] = useState(''); // OK
    const [creci, setCreci] = useState(''); // ok
    const [corretagem, setCorretagem] = useState(''); // ok
    const [cartorio, setCartorio] = useState(''); // ok
    const [mat, setMat] = useState(''); // ok
    const [cnpj, setCnpj] = useState(''); // OK     
    const [naoGravame, setNaoGravame] = useState(false); // OK 
    const [nomeCompleto, setNomeCompleto] = useState(''); // OK 
    const [nomeRazao, setNomeRazao] = useState(''); // OK 
    const [descricao, setDescricao] = useState('');  // Estado para a descrição

    // ref useRef(null);
    const nomeCompletoRef = useRef(null);
    const nomeCorretorRef = useRef(null);

    const creciRef = useRef(null);
    const cpfRef = useRef(null);
    const cnpjRef = useRef(null);
    const matRef = useRef(null);
    const cartorioRef = useRef(null);
    const corretagemRef = useRef(null);
    const valorVendaImovelRef = useRef(null);

    const [tipoCorretor, setTipoCorretor] = useState('')
    // Controle de exibição das listas de opções
    const [showOptions, setShowOptions] = useState(false);

    const Options = ['Imobiliária', 'Corretor'];

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisibleDescricao, setIsModalVisibleDescricao] = useState(false);

    const toggleModalDescricao = () => {
        setIsModalVisibleDescricao(!isModalVisibleDescricao);
    };

    const truncateText = (text, maxLength) => {
        return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
    };

    const isFormValid = () => !!(valorVendaImovel && cpf && cnpj && creci && nomeRazao && nomeCompleto && tipoCorretor && corretagem && cartorio && mat);
    // Função para enviar os dados do imóvel para a API

    const handleSaveImovel = async () => {
        if (!isFormValid()) {
            Alert.alert('Erro', 'Preencha todos os campos obrigatórios.');
            return;
        }

        if (isSubmitting) return; // Impede múltiplos envios

        setIsSubmitting(true); // Desativa o botão
        setLoading(true);

        const formatarNumero = (valor) => Number(valor.replace(/[R$\.\s]/g, '').replace(',', '.'));

        try {
            const payload = {
                "vendedor": nomeCompleto,
                "cpf_mask": cpf,
                "razao_corretor": nomeRazao,
                "cnpj_mask_corretor": cnpj,
                "creci_corretor": creci,
                "cartorio_number": cartorio,
                "mat_number": mat,
                "valor": formatarNumero(valorVendaImovel),
                "corretagem_number": corretagem,
                "pendencia": naoGravame,
                "pendencia_texto": descricao,
                "tipo_template": tipoCorretor === "Imobiliária" ? "autorizacao_imobiliaria" : "autorizacao_corretor"
            };

            console.log("payload:", payload)

            const response = await axios.post('https://docx.imogo.com.br/gerar-pdf/autorizacao', payload);

            if (response.status === 200) {
                const { pdf_name } = response.data;

                if (!pdf_name) {
                    throw new Error("pdf_name não encontrado na resposta da API");
                }

                const docx_name = pdf_name.replace(".pdf", ".docx");

                const imprimir_link_pdf = `https://docx.imogo.com.br/download/${pdf_name}`;
                const imprimir_link_docx = `https://docx.imogo.com.br/download/${docx_name}`;

                const payload_email = {
                    email: emailUser,
                    tipo_doc: "AUTORIZAÇÃO DE VENDA",
                    nome_cliente: nomeCompleto,
                    link_word: imprimir_link_docx,
                    link_pdf: imprimir_link_pdf
                };

                const response_email = await axios.post(
                    "https://smtp.josuejuca.com/imogo/emails/gerador-de-documentos",
                    payload_email
                );

                if (response_email.status === 200) {
                    navigation.navigate("BaixarDocGeradorWeb", { usuario_id, emailUser, pdf_name, docx_name, imprimir_link_pdf, imprimir_link_docx });
                }
            } else {
                console.log(response.data);
                Alert.alert("Erro", "Ocorreu um erro ao fazer o documento");
            }
        } catch (error) {
            console.error(error);
            Alert.alert('Erro', 'Não foi possível fazer o documento');
        } finally {
            setIsSubmitting(false); // Reativa o botão
            setLoading(false);
        }
    };

    const togglenaoGravame = () => setNaoGravame(prev => !prev);

    const selectOptions = (option) => {
        setTipoCorretor(option)
        setShowOptions(false);
    }

    // Função para formatar o valor como moeda (R$)
    const formatCurrency = (value) => {
        if (!value) return '';

        // Remove tudo o que não for número
        const numericValue = value.replace(/[^0-9]/g, '');

        // Converte para número e formata com casas decimais
        const formattedValue = (numericValue / 100).toFixed(2).replace('.', ',');

        // Insere o ponto a cada três dígitos (se necessário)
        return 'R$ ' + formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    return (
        <BaseWeb>
            {(userInfo) => {
                setUsuario_id(userInfo.id)
                setEmailUser(userInfo.email)
                return (
                    <ScrollView contentContainerStyle={styles.contentMinimal}>
                        <View style={styles.formContainer}>
                            <Text style={styles.title}>Autorização de Venda</Text>

                            <View style={styles.proprietarioContainer}>

                                {/* Nome Completo */}
                                <View style={styles.row}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>Nome ou Razão Social do Proprietário*</Text>
                                    <TouchableWithoutFeedback onPress={() => nomeCompletoRef.current.focus()}>
                                        <View style={styles.inputContainer}>
                                            <TextInput
                                                ref={nomeCompletoRef}
                                                allowFontScaling={false}
                                                style={styles.areaInput}
                                                placeholder="Nome ou Razão Social"
                                                value={nomeCompleto}
                                                placeholderTextColor="#A9A9A9"
                                                onChangeText={setNomeCompleto}
                                            />
                                        </View>
                                    </TouchableWithoutFeedback>
                                </View>
                                {/* CPF */}

                                <View style={styles.row}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>CPF ou CNPJ do Proprietário*</Text>
                                    <TouchableWithoutFeedback onPress={() => cpfRef.current.focus()}>
                                        <View style={styles.inputContainer}>
                                            <MaskInput
                                                ref={cpfRef}
                                                allowFontScaling={false}
                                                style={styles.areaInput}
                                                value={cpf}
                                                onChangeText={setCpf}
                                                mask={Masks.BRL_CPF_CNPJ}
                                                placeholderTextColor="#A9A9A9"
                                                keyboardType="numeric"
                                                placeholder="CPF ou CNPJ"
                                            />
                                        </View>
                                    </TouchableWithoutFeedback>
                                </View>

                                {/* Separador visual (Divisão) */}
                                <View style={styles.divider} />

                                <View style={styles.row}>
                                    <Text style={[styles.subLabel, styles.orientacaoText]} allowFontScaling={false}>Você é imobiliária ou corretor de imóveis?</Text>
                                    <View style={styles.orientationGroup}>
                                        {['Corretor', 'Imobiliária'].map((opcao) => (
                                            <TouchableOpacity
                                                key={opcao}
                                                style={[styles.orientationButton, tipoCorretor === opcao && styles.selectedOptionOrientation]}
                                                onPress={() => setTipoCorretor(tipoCorretor === opcao ? '' : opcao)} // Desmarca se já estiver selecionado
                                            >
                                                <Image
                                                    source={tipoCorretor === opcao ? icons[opcao].selected : icons[opcao].default}
                                                    style={{ width: 30, height: 30, marginBottom: 5 }}
                                                />
                                                <Text style={[styles.optionText, tipoCorretor === opcao && styles.selectedOptionText]} allowFontScaling={false}>
                                                    {opcao}
                                                </Text>
                                            </TouchableOpacity>
                                        ))}
                                    </View>
                                </View>

                                {/* Separador visual (Divisão) */}
                                <View style={styles.divider} />
                                <View style={styles.row}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>Seu Nome ou Razão Social*</Text>
                                    <TouchableWithoutFeedback onPress={() => nomeCorretorRef.current.focus()}>
                                        <View style={styles.inputContainer}>
                                            <TextInput
                                                ref={nomeCorretorRef}
                                                allowFontScaling={false}
                                                style={styles.areaInput}
                                                placeholder="Nome ou Razão Social"
                                                value={nomeRazao}
                                                placeholderTextColor="#A9A9A9"
                                                onChangeText={setNomeRazao}
                                            />
                                        </View>
                                    </TouchableWithoutFeedback>
                                </View>

                                {/* CNPJ */}
                                <View style={styles.row}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>Seu CPF ou CNPJ *</Text>
                                    <TouchableWithoutFeedback onPress={() => cnpjRef.current.focus()}>
                                        <View style={styles.inputContainer}>
                                            <MaskInput
                                                ref={cnpjRef}
                                                allowFontScaling={false}
                                                style={styles.areaInput}
                                                value={cnpj}
                                                onChangeText={setCnpj}
                                                mask={Masks.BRL_CPF_CNPJ}
                                                placeholderTextColor="#A9A9A9"
                                                keyboardType="numeric"
                                                placeholder="CPF ou CNPJ"
                                            />
                                        </View>
                                    </TouchableWithoutFeedback>
                                </View>
                                <View style={styles.row}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>Seu CRECI*</Text>
                                    <TouchableWithoutFeedback onPress={() => creciRef.current.focus()}>
                                        <View style={styles.inputContainer}>
                                            <TextInput
                                                ref={creciRef}
                                                allowFontScaling={false}
                                                style={styles.areaInput}
                                                placeholder="Número do CRECI"
                                                value={creci}
                                                keyboardType='numeric'
                                                placeholderTextColor="#A9A9A9"
                                                onChangeText={setCreci}
                                            />
                                        </View>
                                    </TouchableWithoutFeedback>
                                </View>
                                {/* Separador visual (Divisão) */}
                                <View style={styles.divider} />
                                <View style={styles.row}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>Percentual de Corretagem negociado com o cliente (%)*</Text>
                                    <TouchableWithoutFeedback onPress={() => corretagemRef.current.focus()}>
                                        <View style={styles.inputContainer}>
                                            <TextInput
                                                ref={corretagemRef}
                                                allowFontScaling={false}
                                                style={styles.areaInput}
                                                placeholder="Percentual (%)"
                                                value={corretagem}
                                                keyboardType='numeric'
                                                placeholderTextColor="#A9A9A9"
                                                onChangeText={setCorretagem}
                                            />
                                        </View>
                                    </TouchableWithoutFeedback>
                                </View>

                                {/* Valor de venda do imóvel */}
                                <View style={styles.row}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>Valor de venda do imóvel *</Text>
                                    <TouchableWithoutFeedback onPress={() => valorVendaImovelRef.current.focus()}>
                                        <View style={styles.inputContainer}>
                                            <TextInput
                                                ref={valorVendaImovelRef}
                                                style={styles.areaInput}
                                                placeholder="R$"
                                                value={valorVendaImovel}
                                                onChangeText={(text) => setValorVendaImovel(formatCurrency(text))}
                                                keyboardType="numeric"
                                                allowFontScaling={false}
                                                placeholderTextColor="#A9A9A9"
                                                pointerEvents="auto"
                                            />
                                        </View>
                                    </TouchableWithoutFeedback>
                                </View>
                                {/* Inputs de Área */}
                                {/* <View style={[styles.areaRow]}> */}
                                {/* Área Privativa */}
                                <View style={styles.row}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>Cartório de Registro do Imóvel*</Text>
                                    <TouchableWithoutFeedback onPress={() => cartorioRef.current.focus()}>
                                        <View style={styles.inputContainer}>
                                            <TextInput
                                                style={styles.areaInput}
                                                placeholder="N° do cartório"
                                                ref={cartorioRef}
                                                allowFontScaling={false}
                                                value={cartorio}
                                                keyboardType='numeric'
                                                placeholderTextColor="#A9A9A9"
                                                onChangeText={setCartorio}
                                            />
                                        </View>
                                    </TouchableWithoutFeedback>
                                </View>

                                {/* Área Total */}
                                <View style={styles.row}>
                                    <Text style={styles.subLabel} allowFontScaling={false}>Matrícula do Imóvel*</Text>
                                    <TouchableWithoutFeedback onPress={() => matRef.current.focus()}>
                                        <View style={styles.inputContainer}>
                                            <TextInput
                                                style={styles.areaInput}
                                                placeholder="N° da matrícula"
                                                ref={matRef}
                                                allowFontScaling={false}
                                                value={mat}
                                                keyboardType='numeric'
                                                placeholderTextColor="#A9A9A9"
                                                onChangeText={setMat}
                                            />
                                        </View>
                                    </TouchableWithoutFeedback>
                                </View>
                                {/* </View> */}

                                {/* Checkbox "Não possui condomínio" */}
                                <View style={styles.checkboxRow}>
                                    <Checkbox
                                        value={naoGravame}
                                        onValueChange={togglenaoGravame}
                                        color={naoGravame ? '#730d83' : undefined}
                                    />
                                    <Text style={styles.checkboxLabel} allowFontScaling={false}>Possui gravame</Text>
                                </View>
                                {naoGravame && (
                                    <View style={[styles.row, styles.mt_10]}>
                                        <Text style={styles.subLabel} allowFontScaling={false}>Descrição do gravame </Text>
                                        <TouchableOpacity style={styles.descriptionBox} onPress={toggleModalDescricao}>
                                            <Text style={[styles.descriptionText, descricao ? styles.descriptionFilled : styles.placeholderText]} allowFontScaling={false}>
                                                {truncateText(descricao, 30)}
                                            </Text>
                                        </TouchableOpacity>
                                        <Text style={styles.helperText} allowFontScaling={false}>
                                            Descreva aqui da melhor forma possível as pendência que o imóvel possui.
                                        </Text>
                                    </View>
                                )}

                                {/* Modal de Descrição */}
                                <DescricaoModal
                                    isVisible={isModalVisibleDescricao}
                                    toggleModal={toggleModalDescricao}
                                    descricao={descricao}
                                    setDescricao={setDescricao}
                                />
                                {/* Separador visual (Divisão) */}
                                <View style={styles.divider} />

                                <View style={styles.buttonContainer}>
                                    <TouchableOpacity
                                        style={[
                                            styles.saveButton,
                                            (!isFormValid() || isSubmitting) && { backgroundColor: '#ccc' }
                                        ]}
                                        onPress={handleSaveImovel}
                                        disabled={!isFormValid() || isSubmitting}
                                    >
                                        <Text style={styles.saveButtonText} allowFontScaling={false}>
                                            {isSubmitting ? 'Enviando...' : 'Gerar Documento'}
                                        </Text>
                                    </TouchableOpacity>

                                    <TouchableOpacity style={styles.laterButton}>
                                        <Image
                                            source={require('../../assets/icons/home.png')} // Ícone de terminar mais tarde
                                            style={styles.laterIcon}
                                        />
                                        <Text style={styles.laterButtonText} allowFontScaling={false}
                                            onPress={() => navigation.navigate('HomeWeb', { usuario_id })}
                                        >Voltar</Text>
                                    </TouchableOpacity>
                                </View>
                            </View>

                        </View>
                    </ScrollView>
                );
            }}
        </BaseWeb>
    );
}
